import type { BulkField } from '../types'

export function compareNumberValue(
  bulkValue: BulkField<number>,
  orderValue: number,
): BulkField<number> {
  // If already mixed, stay mixed
  if (bulkValue === 'mixed') return 'mixed'

  // If values don't match (including one null, one not), return mixed
  if (bulkValue !== orderValue) return 'mixed'

  // If values match and neither is mixed, return the value
  return bulkValue
}
